export default __webpack_public_path__ + "static/media/default.476de4e4.jpg";